import { FC, useState, useCallback, useEffect, ComponentProps } from 'react'

import { ButtonProps } from '~ui/Button'

type FollowButtonProps = {
  isFollowed: boolean
} & ButtonProps &
  ComponentProps<'button'>

const FollowButton: FC<FollowButtonProps> = ({ isFollowed, ...props }) => {
  const [buttonText, setButtonText] = useState('Follow')

  const onMouseOver = useCallback(() => {
    if (isFollowed) {
      setButtonText('Stop Following')
    }
  }, [isFollowed])

  const onFollowingTextChange = useCallback(() => {
    setButtonText(isFollowed ? 'Following' : 'Follow')
  }, [isFollowed])

  useEffect(() => {
    onFollowingTextChange()
  }, [onFollowingTextChange])

  return (
    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
    <button
      {...props}
      type="button"
      className="btn btn-primary"
      onFocus={onMouseOver}
      onMouseLeave={onFollowingTextChange}
      onMouseOver={onMouseOver}
    >
      {buttonText}
    </button>
  )
}

export default FollowButton
